<template>
    <div class="conference-actions">
        <button class="btn btn--danger" @click="cancelOpen = true">Отменить конференцию</button>
        <button class="btn btn--primary" @click="promptSendInvitations">Отправить приглашения</button>
        <button class="btn btn--danger" @click="confirmForceEnd">Принудительно завершить</button>

        <CancelConferenceDialog
            v-if="cancelOpen"
            :open="cancelOpen"
            :conference-id="conferenceId"
            @close="cancelOpen = false"
            @done="onDone"
        />
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';
import CancelConferenceDialog from './CancelConferenceDialog.vue';

const props = defineProps<{ detail: { id: number | string } }>();

const cancelOpen = ref(false);
const busy = ref(false);

const conferenceId = (): string => String(props.detail.id);

async function promptSendInvitations(): Promise<void> {
    const input = window.prompt('Введите UUID участников через запятую:');
    if (input === null) return;
    const participantPks = input
        .split(',')
        .map((s: string) => s.trim())
        .filter((s: string) => s.length > 0);
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/conferences/${conferenceId()}/send-invitations/`,
            data: { participant_pks: participantPks },
        });
        window.alert('Приглашения отправлены');
    } finally {
        busy.value = false;
    }
}

async function confirmForceEnd(): Promise<void> {
    if (!window.confirm('Принудительно завершить конференцию?')) return;
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/conferences/${conferenceId()}/force-end/`,
            data: {},
        });
        onDone();
    } finally {
        busy.value = false;
    }
}

function onDone(): void {
    cancelOpen.value = false;
    window.location.reload();
}
</script>

<style scoped>
.conference-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}

@media (max-width: 640px) {
    .conference-actions .btn { min-height: 2.5rem; }
}
</style>
